import { render, staticRenderFns } from "./PrepaymentSettings.vue?vue&type=template&id=33272bf2"
import script from "./PrepaymentSettings.vue?vue&type=script&lang=js"
export * from "./PrepaymentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports